import React from 'react';
import '../../components/style.css';
import Image from '../../pics';

function experience() {
  return (
    <div>
        <div className="uk-section">
            <div className="uk-container">
                <h2 className="text-primary uk-text-center">
                    Experience the excellence 
                </h2>
                <div className="uk-child-width-1-3@m uk-grid-small uk-grid-match" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-body">
                            <img src={Image.SIMPLIFY_BOOKING} alt='simplified' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Simplified Booking
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                Easily book and schedule pickups for your shipments - Just fill the form, upload KYC & invoice. Rest assured, it ensures on-time pickup arrival for every shipment.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <img src={Image.PICKUP} alt='automated pick up' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Automated Pick-up
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                Experience streamlined pickup processes with automated procedures. Our executives diligently follows protocols to ensure the efficient collection of your shipments.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <img src={Image.DELIVERED} alt='secure' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Secure Delivery 
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                Benefit from secure deliveries with insurance coverage & real time tracking. Each shipment is carefully handled, sealed, & scanned for maximum protection during transit.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default experience